import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Stack} from 'views/components';

import {Translate, translate} from 'views/module';

import moment from 'moment';

const WorkHistorySection = (props) => {
  const {questions} = props;

  const workHistory = questions.workHistory || [];

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = moment(dateStr);
    if (!date.isValid()) return '';
    return date.format('MMM YYYY');
  };

  const getDuration = (start, end) => {
    if (!start) return '';

    const startDate = moment(start);
    const endDate = end ? moment(end) : moment();

    if (!startDate.isValid() || !endDate.isValid() || endDate.isBefore(startDate)) return '';

    const duration = moment.duration(endDate.diff(startDate));
    const years = Math.floor(duration.asYears());
    const months = Math.floor(duration.asMonths() - years * 12);

    let result = '';
    if (years > 0) {
      if (months > 0) {
        result = translate('caregiverDetail.WorkHistory.Timeline.YearMonthFormat', {years, months});
      } else {
        result = translate('caregiverDetail.WorkHistory.Timeline.YearFormat', {years, months});
      }
    } else if (months > 0) {
      result = translate('caregiverDetail.WorkHistory.Timeline.MonthFormat', {years, months});
    }

    return result;
  };

  function workEntryHasMinimumData(workEntry) {
    return workEntry.employerName && workEntry.startDate;
  }

  return (
    workHistory.length > 0 && workHistory.some((e) => workEntryHasMinimumData(e)) &&
    <Stack alignItems="flex-start" width="100%" spacing={2}>
      <Typography
        variant="body1"
        fontWeight="bold"
        sx={{
          color: '#686868',
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
        }}
      >
        <Translate expression='caregiverDetail.WorkHistory.Subtitle'/>
      </Typography>
      {/* Work History Subsection */}

      <Stack spacing={2} width="100%">
        {
          workHistory.map((e) => (
            workEntryHasMinimumData(e) &&
              <Stack
                key={e.employerName + e.startDate + e.endDate}
                direction="row"
                alignItems="flex-start"
                justifyContent="center"
                spacing={2}
                width="100%"
              >
                {/* Card */}
                <Stack
                  alignItems="flex-start" justifyContent="flex-start" spacing={0.5}
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    bgcolor: 'color.white',
                    width: '100%',
                    boxSizing: 'border-box',
                    border: '1px solid',
                    borderColor: 'color.divider',
                    m: 0,
                    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.08)',
                  }}
                >
                  <Typography variant="subtitle2" fontWeight="bold">
                    {e.employerName}
                  </Typography>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="body2" color="#686868">
                      {formatDate(e.startDate)}
                      —
                      {(e.endDate ? formatDate(e.endDate) : translate('caregiverDetail.WorkHistory.EndDatePresent'))}
                    </Typography>
                    <Typography>
                      {'\u00B7'}
                    </Typography>
                    <Typography variant="body2" color="#686868">
                      {getDuration(e.startDate, e.endDate)}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
          ))
        }
      </Stack>
    </Stack>
  );
};

WorkHistorySection.propTypes = {
  questions: PropTypes.object.isRequired,
};

export default WorkHistorySection;
